<template>
  <v-card id="polygon-download-dialog">
    <v-card-title class="primary white--text">
      <v-row dense>
        <v-col cols="auto">
          <Icon
          icon="geojson"
          :small="false"
          iconColor="tertiary"
          :tooltipText="$t('geoJSON')"
          />
        </v-col>
        <v-col>
          <span>
            {{ title }}
          </span>
        </v-col>
        <v-col cols="auto">
          <BaseDialogActions
          hideRefresh
          hideFullscreen/>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pt-3">
      <v-container fluid>
        <v-checkbox
          v-model="cut"
          :disabled="!cutEnabled"
          class="my-0"
          :label="$t('cutLayer')"
          id="cut-checkbox">
        </v-checkbox>
        <v-checkbox
          v-model="parcels"
          :disabled="!parcelsEnabled"
          class="my-0"
          :label="$t('parcelLayer')"
          id="parcel-checkbox">
        </v-checkbox>
      </v-container>
    </v-card-text>
    <v-card-actions class="mx-0">
      <v-row justify="end" class="ma-0">
        <v-col cols="auto">
          <v-btn
          id="download"
          @click="downloadClicked"
          color="primary">
            {{ $t('download') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
import { AngelGeojson, AngelGeojsonLayer } from '@/utils/map/Geojson'

const CUT = AngelGeojsonLayer.Cut
const PARCELS = AngelGeojsonLayer.Parcels

export default {
  name: 'PolygonDownloadDialog',

  props: {
    angelGeojson: {
      type: AngelGeojson,
      required: true
    },

    tract: {
      type: Object,
      required: true
    }
  },

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue'),
    Icon: () => import('@/components/helper/Icon.vue')
  },

  data: () => ({
    cutEnabled: false,
    parcelsEnabled: false,
    cut: false,
    parcels: false
  }),

  created () {
    this.cut = this.hasCut
    this.cutEnabled = this.hasCut
    this.parcelsEnabled = this.hasParcels
  },

  watch: {
    cut (value) {
      if (!value && !this.parcels) this.parcels = true
    },

    parcels (value) {
      if (!value && !this.cut) this.cut = true
    }
  },

  computed: {
    title () {
      return this.$t('downloadShape')
    },

    hasCut () {
      return this.angelGeojson.layerIsNotEmpty(CUT)
    },

    hasParcels () {
      return this.angelGeojson.layerIsNotEmpty(PARCELS)
    },

    allGeojsonLayersSelected () {
      return this.cut && this.parcels
    }
  },

  methods: {
    downloadClicked () {
      if (this.allGeojsonLayersSelected) {
        this.angelGeojson.download(this.tract.name)
      } else {
        if (this.cut) {
          this.angelGeojson.downloadLayer(this.tract.name, CUT)
        } else if (this.parcels) {
          this.angelGeojson.downloadLayer(this.tract.name, PARCELS)
        }
      }

      this.$emit('done')
    }
  }
}
</script>
